<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'20px'}" id="outermost">
      <van-nav-bar
        title="添加企业"
        left-text="返回"
        left-arrow
        @click-left="$router.back()"
        id="topbar"
      />
      <div style="padding:20px">
        <form action="/">
          <van-search
            v-model="companyName"
            placeholder="请输入企业名称"
            @search="onSearch"
            shape="round"
            background="#F7F7F7"
          />
              <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              :immediate-check="false"
              >
                <div v-for="(item,index) in companyList" :key="index" class='companyItem'>
                  <div class='sellout' @click="toCompanyInfo(item.id)">
                    {{item.typeName}}
                  </div>
                  <div class="companyName" @click="toCompanyInfo(item.id)">
                    {{item.companyName}}
                  </div>
                  <div class="companyLink" @click="toCompanyInfo(item.id)">
                    联系人：<span>{{item.contacts1}}</span>
                  </div>
                  <div class="companyLink">
                    <van-row type="flex" justify="space-between" align="center">
                      <van-col @click="toCompanyInfo(item.id)">
                        联系电话：<span>{{item.phone1}}</span>
                      </van-col>
                      <van-col style="color:#1B75F6">
                        <van-button color="#1B75F6" class="addBtn" native-type="button" @click="bindingCompany(item.id)">添加</van-button>
                      </van-col>
                    </van-row>
                  </div>
                </div>
              </van-list>
        </form>
      </div>
      <div style="position: fixed;bottom: 0px;width: 100%;">
          <van-button block color="#1B75F6" native-type="button" @click="createCompany">新建企业</van-button>
      </div>
    </div>
</template>
<script>
    import $ from '@/fly'
    import { Dialog, Toast } from 'vant'
    export default {
        name: 'project-thirdPartyCompany',
        data () {
            return {
                clientHeight: window.screen.height,
                companyName: '',
                proName: '',
                loading: true,
                finished: false,
                companyList: []
            }
        },
        computed: {
        },
        methods: {
            onSearch () {
                this.loadList();
            },
            loadList () {
                var that = this;
                $.get('company/findCompanyNotInProject', {
                    companyName: this.companyName,
                    projectId: localStorage.getItem('projectId')
                }).then(res => {
                    that.companyList = res;
                    // 加载状态结束
                    that.loading = false;
                    that.finished = true;
                })
            },
            toCompanyInfo (id) {
                localStorage.setItem('companyId', id);
                this.$router.push({ name: 'project-companyInfo' });
            },
            createCompany () {
                this.$router.push({ name: 'project-addCompany' });
            },
            async bindingCompany (companyId) {
                Dialog.confirm({
                    title: '是否确认添加该企业'
                }).then(() => {
                    // 获取已绑定的企业id
                    // var companyIds = localStorage.getItem('bindCompanyIds');
                    //
                    // if(companyIds!==''&&companyIds!==undefined&&companyIds!==null){
                    //   $.post('projectCompany', {
                    //     projectId: localStorage.getItem('projectId'),
                    //     companyIds: companyIds+','+companyId
                    //   }).then(res => {
                    //     Toast.success('添加成功！');
                    //     this.$router.back();
                    //   }).catch(err => {
                    //     Toast.fail(err.message);
                    //   })
                    // }else{
                      $.post('projectCompany', {
                        projectId: localStorage.getItem('projectId'),
                        companyIds: companyId,
                        type:'mobile',
                      }).then(() => {
                        Toast.success('添加成功！');
                        this.$router.back();
                      }).catch(err => {
                        Toast.fail(err.message);
                      })
                    // }
                })
            }
        },
        mounted () {
            this.proName = localStorage.getItem('projectName');
            this.loadList();
        }
    }

</script>

<style lang="less" scoped>
  .van-search{
    padding: 0px;
  }
  .van-list{
    margin-top:20px;
  }
  .companyItem {
    width: 100%;
    min-height: 190px;
    background-color: white;
    margin: 10rpx 0;
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    padding: 0px 30px;
    border:1px solid #1B75F6;
  }

  .sellout {
    background-color: #1B75F6;
    color: white;
    font-size: 18px;
    font-weight: 300;
    width: 70%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    margin-left: 54%;
    margin-top: 30px;
    position: absolute;
    transform: rotate(45deg);
  }
  .companyName{
    color: #1F56F4;
    font-size: 30px;
    font-weight: 800;
    line-height: 70px;
    margin-top: 10px;
  }
  .companyLink{
    color: #464646;
    font-size: 20px;
    font-weight: 500;
    line-height: 45px;
  }
  .addBtn{
    border-radius: 10px;
    height:50px;
    line-height:50px;
  }
</style>
